module.exports = __webpack_public_path__ + "img/promo-bg.5801fe2.jpg";